import { composeReducer } from 'redux-compose-reducer';
import _ from 'lodash';

const initialState = {
  pagination: {
    current: 0,
    pageSize: 500,
    total: 501
  },
  filters: {},
  messages: [],
  participants: [],
  actionsCnt: 0,
  signal: null,
  uuid: null,
  participantProfileData: null
};


function getMessages(state, { data, pagination, uuid, filters }) {
  const { offset } = data.pagination;
  const messages = state.messages;
  data.data.forEach((v, i) => messages[offset + i] = v);

  return {
    ...state,
    messages: messages,
    filters: filters,
    uuid: uuid,
    participants: data.participants,
    pagination: { ...state.pagination, ...pagination, ...data.pagination }
  };
}


function sendMessage(state, { data }) {
  return {
    ...state,
    actionsCnt: state.actionsCnt + 1,
    messages: [data, ...state.messages]
  };
}


function receiveMessages(state, { data }) {
  let messages = state.messages;
  let overwriteFlag = false;

  _.forEach(messages, (n, i) => {
    if (n.clientId === data.clientId) {
      messages[i] = data;
      overwriteFlag = true;
    }

    if (n.uuid === data.uuid) { // to update suggestions
      messages[i] = data;
      overwriteFlag = true;
    }
  });

  if (!overwriteFlag) {
    messages = [data, ...state.messages];
  }

  return {
    ...state,
    actionsCnt: state.actionsCnt + 1,
    messages: messages
  };
}


function receiveSignals(state, { signal, uuid }) {
  return {
    ...state,
    actionsCnt: state.actionsCnt + 1,
    signal: signal,
    uuid: uuid
  };
}


function getProfileData(state, { data }) {
  return {
    ...state,
    participantProfileData: data
  };
}


function wipeChatData() {
  return {
    ...initialState,
    messages: []
  };
}


export default composeReducer('chat', {
  getMessages,
  sendMessage,
  receiveMessages,
  receiveSignals,
  getProfileData,
  wipeChatData
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/chat.js